module.exports = __webpack_public_path__ + "img/banner2.64872474.jpg";